module.exports = __webpack_public_path__ + "img/success.272593d8.svg";